import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import ModalBase from "../modalBase/modalBase";
import AvoidTagsFilter from "../avoidTagsFilter/avoidTagsFilter";
import { Action, Getter } from "vuex-class";

@Component({
  components: {
    ModalBase,
    AvoidTagsFilter,
  },
})
export default class ModalDishFilters extends Vue {
  @Prop({ default: false }) isShowingModal;
  @Prop({ default: () => [] }) currentSelectedTags;
  @Prop({ default: -1 }) menuId;

  @Action action_getTags;

  @Getter getCity;

  isLoading = false;
  availableTags = [];
  selectedTags = [];

  async mounted() {
    this.isLoading = true;
    this.availableTags = await this.action_getTags();
    this.onCurrentSelectedTagsChange();
    this.isLoading = false;
  }

  @Watch("currentSelectedTags")
  onCurrentSelectedTagsChange() {
    this.selectedTags = [...this.currentSelectedTags];
  }

  onSelectTag(newTag) {
    const findIndex = this.selectedTags.findIndex((tag) => newTag.id === tag.id);
    if (findIndex !== -1) {
      this.selectedTags.splice(findIndex, 1);
    } else {
      this.selectedTags.push(newTag);
    }
  }

  get getAvoidProteins() {
    return this.availableTags.filter((tag) => tag.type_tag === "aggregate");
  }

  get getAvoidOtherTypesOfFood() {
    return this.availableTags.filter((tag) => tag.type_tag === "avoid");
  }
}
